import { render, staticRenderFns } from "./CredentialsAlfaSignAdmin.vue?vue&type=template&id=87d09244"
import script from "./CredentialsAlfaSignAdmin.vue?vue&type=script&lang=js"
export * from "./CredentialsAlfaSignAdmin.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports